import { render } from "./ConfirmEmailTiers.vue?vue&type=template&id=58e239f2&scoped=true&ts=true"
import script from "./ConfirmEmailTiers.vue?vue&type=script&lang=ts"
export * from "./ConfirmEmailTiers.vue?vue&type=script&lang=ts"

import "./ConfirmEmailTiers.vue?vue&type=style&index=0&id=58e239f2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\LolaClean\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e239f2"]])

export default __exports__